<template>
  <div
    class="form-group former-editor"
    :class="[
      { 'former-has-value': model[field.key], 'has-error': hasError },
      field.className,
    ]"
  >
    <AceEditor v-model="model[field.key]"/>
    <error-display :form="form" :field="field.key"></error-display>
  </div>
</template>

<script>
import baseField from './baseField'

export default {
  name: 'formerAceEditor',
  mixins: [baseField]
}
</script>
